import React from 'react';
import { rgba } from 'polished';

const Suitcase = ({ fill, ...props }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill={fill ?? rgba('#FFFFFF', 0.3)}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.5 3.938h-6.25V2.625A2.568 2.568 0 0018.75 0h-7.5a2.569 2.569 0 00-2.5 2.625v1.313H2.5A2.569 2.569 0 000 6.562V10.5a2.568 2.568 0 002.5 2.625h10v-.662a.633.633 0 01.626-.65h3.75a.634.634 0 01.625.65v.662h10A2.568 2.568 0 0030 10.5V6.562a2.568 2.568 0 00-2.5-2.624zm-8.75 0h-7.5V2.625h7.5v1.313zm10.9 9.9a.589.589 0 00-.65.062 2.424 2.424 0 01-1.5.538h-10V16.4a.643.643 0 01-.624.663h-3.75a.643.643 0 01-.625-.663v-1.962h-10A2.424 2.424 0 011 13.9a.59.59 0 00-.65-.063.65.65 0 00-.35.588v9.2a2.568 2.568 0 002.5 2.625h25a2.568 2.568 0 002.5-2.625v-9.2a.65.65 0 00-.35-.588z"
      />
    </svg>
  );
};

export default Suitcase;
